import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useCallback, useEffect, useMemo, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Header from "components/Headers/Header";
import Select from "react-select";
import JoditEditor from "jodit-react";
import VariablesPorContrato from "views/examples/VariablesPorContrato";
import { FaPencilAlt } from "react-icons/fa";

const ContratoVariables = (props) => {
  const [postContrato, setPostContrato] = useState([]);
  const [content, setContent] = useState("");
  const [logs, setLogs] = useState([]);

  const config = useMemo(
    () => ({
      readonly: false,
    }),
    [],
  );
  const appendLog = useCallback(
    (message) => {
      console.log("logs = ", logs);
      const newLogs = [...logs, message];
      setLogs(newLogs);
    },
    [logs, setLogs],
  );

  const onChange = useCallback(
    (newContent) => {
      appendLog(`onChange triggered with ${newContent}`);
    },
    [appendLog],
  );

  useEffect(() => {
    console.log("onChange = ", onChange);
  }, [onChange]);

  const onBlur = useCallback(
    (newContent) => {
      appendLog(`onBlur triggered with ${newContent}`);
      setContent(newContent);
    },
    [appendLog, setContent],
  );
  const [postVariable, setPostVariable] = useState([]);
  const [postContenido, setPostContenido] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/CreaContratosVariables",
      data: {
        idContrato: props.id,
        variable: postVariable.label,
        contenidoVariable: content,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };
  const postGenera = (e) => {
    e.preventDefault(e);
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://contratosback.azurewebsites.net/api/v1/GeneraContrato/" +
        props.id,
    })
      .then((Response) => {
        console.log(Response.data);
        alert("generado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  const [options, setOptions] = useState([]);

  //se usa metodo GET para recibir la informacion de la API que necesitemos.

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://contratosback.azurewebsites.net/api/v1/ObtieneVariablesContratos/" +
        props.tipo,
    })
      //nos da la respuesta mediante un mapeo
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.variable,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };
  return (
    <>
      <button
        variant="contained"
        className="btn btn-info"
        color="primary"
        onClick={handleOpenModalTest}
        title=""
        style={{ padding: "5px 5px", fontSize: "10px" }}
      >
        Diligenciar Contrato
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
        style={{
          overlay: { zIndex: 2000 },
        }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",

            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        {/* Page content */}
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Contratos Varibales</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      contrato variable
                    </h6>
                    {/* Description */}
                    <div className="pl-lg-4">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-username"
                        >
                          Id Contrato
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-postal-code"
                          placeholder={props.id}
                          type="text"
                          disabled
                        />
                        <label
                          className="form-control-label"
                          htmlFor="input-username"
                        >
                          Variable
                        </label>
                        <FormGroup>
                          <Select
                            name="colors"
                            options={options}
                            classNamePrefix="select"
                            onChange={setPostVariable}
                          />
                        </FormGroup>

                        <div style={{ textAlign: "right" }}>
                          <button
                            className="btn btn-danger btn-lg"
                            color="primary"
                            onClick={postGenera}
                          >
                            GENERAR CONTRATO
                          </button>
                        </div>

                        <br />
                        <label
                          className="form-control-label"
                          htmlFor="input-username"
                        >
                          Contenido Variable
                        </label>
                        <JoditEditor
                          value={content}
                          config={config}
                          tabIndex={1}
                          onBlur={onBlur}
                          onChange={onChange}
                        />
                      </FormGroup>
                      <br />
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        Guardar variable
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <VariablesPorContrato idContrato={props.id} />
      </ReactModal>
    </>
  );
};

export default ContratoVariables;
